<div *ngIf="message" [ngClass]="message.cssClass" style="margin-top:10px;text-align: center;">{{message.text}}</div>